export default [
    {
        key: 'display',
        components: [
            {
                key: 'labelPosition',
                ignore: true,
            },
            {
                key: 'placeholder',
                ignore: true,
            },
            {
                key: 'label',
                label: 'Payment Methods label',
                tooltip: 'Set the label for the payment method options',
                defaultValue: 'Payment Methods',
            },
            {
                key: 'default_paymentmethod_once',
                type: 'select',
                label: 'Default Method Single Payments',
                tooltip: "Set the default payment method in case 'once' is selected as frequency.",
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                weight: 180,
                data: {
                    custom: function custom(ctx) {
                        var methods = [];
                        ['ideal', 'directdebit', 'paypal', 'creditcard'].forEach(function (meth) {
                            var method = ctx.data[meth];
                            if (method && ctx.data[meth + "_once"]) {
                                methods.push({
                                    value: meth,
                                    label: ctx.data[meth + "_label"]
                                });
                            }
                        });
                        return methods;
                    }
                },
                validate: {
                    required: true
                }
            },
            {
                key: 'default_paymentmethod_monthly',
                type: 'select',
                label: 'Default Method Monthly Payments',
                tooltip: "Set the default payment method in case 'monthly' is selected as frequency.",
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                weight: 180,
                data: {
                    custom: function custom(ctx) {
                        var methods = [];
                        ['ideal', 'directdebit', 'paypal', 'creditcard'].forEach(function (meth) {
                            var method = ctx.data[meth];
                            if (method && ctx.data[meth + "_monthly"]) {
                                methods.push({
                                    value: meth,
                                    label: ctx.data[meth + "_label"]
                                });
                            }
                        });
                        return methods;
                    }
                },
                validate: {
                    required: true
                }
            },
            {
                key: 'default_paymentmethod_yearly',
                type: 'select',
                label: 'Default Method Yearly Payments',
                tooltip: "Set the default payment method in case 'yearly' is selected as frequency.",
                dataSrc: 'custom',
                template: '<span>{{ item.label }}</span>',
                valueProperty: 'value',
                weight: 180,
                data: {
                    custom: function custom(ctx) {
                        var methods = [];
                        ['ideal', 'directdebit', 'paypal', 'creditcard'].forEach(function (meth) {
                            var method = ctx.data[meth];
                            if (method && ctx.data[meth + "_yearly"]) {
                                methods.push({
                                    value: meth,
                                    label: ctx.data[meth + "_label"]
                                });
                            }
                        });
                        return methods;
                    }
                },
                validate: {
                    required: true
                }
            },
        ]
    },
];
